import { Container } from "@/components/layout/Container"
import { Eyebrow } from "@/components/shared/Eyebrow"
import type { ProductDescriptionBlock } from "@/content/products-content"

interface ProductDescriptionProps {
	blocks: ProductDescriptionBlock[]
}

/**
 * Descripción del producto. Eyebrow arriba y centrado siempre. Debajo, en
 * pantallas medianas y grandes, dos columnas donde cada una lleva su imagen
 * arriba, luego el título y luego el texto (las dos imágenes quedan alineadas
 * arriba). En móvil las columnas se apilan una sobre otra. Imágenes ligeras con
 * aspecto reservado y carga diferida para no penalizar el performance.
 */
export function ProductDescription({ blocks }: ProductDescriptionProps): React.JSX.Element {
	return (
		<section className="bg-background">
			<Container className="py-16 md:py-24">
				<Eyebrow align="center">Características generales</Eyebrow>

				<div className="mt-10 grid grid-cols-1 gap-10 md:mt-14 md:grid-cols-2 md:gap-12">
					{blocks.map((block, i) => (
						<div key={i} className="text-center">
							<img
								src={block.image}
								alt=""
								aria-hidden
								loading="lazy"
								className="aspect-square w-full rounded-2xl object-cover"
							/>
							{block.heading && (
								<h3 className="mt-6 text-balance text-xl font-semibold tracking-tight sm:text-2xl">
									{block.heading}
								</h3>
							)}
							<p className="mt-3 text-pretty leading-relaxed text-muted-foreground">{block.body}</p>
						</div>
					))}
				</div>
			</Container>
		</section>
	)
}
